"use strict";
module.exports = {
    // General settings for the compiled code
    options: {
        namespace: 'uil',
        important: false,
        separator: '\\:',
    },
    // Define your breakpoints
    breakpoints: {
        xs: '500px',
        sm: '768px',
        md: '960px',
        lg: '1200px',
        xl: '1440px',
        xxl: '1920px',
    },
    // Define your brand colors and any others you might want to reuse across your project
    colors: {
        transparent: 'transparent',
        white: '#fff',
        'grey-900': '#23263B',
        'grey-800': '#36395A',
        'grey-700': '#484C7A',
        'grey-600': '#5A5E9A',
        'grey-500': '#777AAF',
        'grey-400': '#9698C3',
        'grey-300': '#B6B7D5',
        'grey-200': '#D6D6E7',
        'grey-100': '#F5F5FA',
        'grey-050': '#FCFCFD',
        'grey-000': '#FFFFFF',
        'pink-900': '#59063D',
        'pink-800': '#88085C',
        'pink-700': '#B80979',
        'pink-600': '#E90A96',
        'pink-500': '#F82CAA',
        'pink-400': '#FB5ABC',
        'pink-300': '#FD89CE',
        'pink-200': '#FEB9E2',
        'pink-100': '#FFEAF6',
        'nebula-900': '#141D61',
        'nebula-800': '#1E2B8F',
        'nebula-700': '#2B3CBB',
        'nebula-600': '#3C4FE0',
        'nebula-500': '#5468FF',
        'nebula-400': '#7C8AFF',
        'nebula-300': '#A3ACFF',
        'nebula-200': '#CACFFF',
        'nebula-100': '#F2F3FF',
        'cyan-900': '#00526C',
        'cyan-800': '#00769B',
        'cyan-700': '#009BCB',
        'cyan-600': '#0DB7EB',
        'cyan-500': '#2CC8F7',
        'cyan-400': '#5ADAFF',
        'cyan-300': '#89E5FF',
        'cyan-200': '#B9EFFF',
        'cyan-100': '#E8FAFF',
        'green-900': '#005E36',
        'green-800': '#028950',
        'green-700': '#06B66C',
        'green-600': '#0DE589',
        'green-500': '#5FEB9E',
        'green-400': '#88F0B3',
        'green-300': '#AAF4C8',
        'green-200': '#C9F8DE',
        'green-100': '#E6FCF3',
        'orange-900': '#963209',
        'orange-800': '#BF470A',
        'orange-700': '#E8600A',
        'orange-600': '#F78125',
        'orange-500': '#FAA04B',
        'orange-400': '#FCBC73',
        'orange-300': '#FED59A',
        'orange-200': '#FFE9C3',
        'orange-100': '#FFF9EC',
        'red-900': '#83111E',
        'red-800': '#AB1325',
        'red-700': '#D4142A',
        'red-600': '#EE243C',
        'red-500': '#F4495D',
        'red-400': '#F86E7E',
        'red-300': '#FC95A1',
        'red-200': '#FEBDC5',
        'red-100': '#FFE6E9',
        //  Product's colors
        'color-predict': '#FFA724',
        'color-answer': '#952AFF',
        'color-recommend': '#FF2A6A',
    },
    // Spacing is used mainly for paddings and margins
    spacing: {
        0: 0,
        1: '1px',
        4: '4px',
        8: '8px',
        12: '12px',
        16: '16px',
        20: '20px',
        24: '24px',
        32: '32px',
        40: '40px',
        48: '48px',
        62: '62px',
        70: '70px',
        80: '80px',
        90: '90px',
        110: '110px',
        120: '120px',
        170: '170px',
        '50p': '50%',
        '80p': '80%',
    },
    // Sizes are for widths and heights mostly
    sizes: {
        0: 0,
        1: '1px',
        4: '4px',
        10: '10px',
        14: '14px',
        16: '16px',
        18: '18px',
        20: '20px',
        24: '24px',
        25: '25px',
        30: '30px',
        35: '35px',
        40: '40px',
        50: '50px',
        60: '60px',
        70: '70px',
        75: '75px',
        80: '80px',
        90: '90px',
        100: '100px',
        170: '170px',
        200: '200px',
        240: '240px',
        300: '300px',
        350: '350px',
        400: '400px',
        450: '450px',
        500: '500px',
        600: '600px',
        700: '700px',
        750: '750px',
        800: '800px',
        900: '900px',
        '10p': '10%',
        '20p': '20%',
        '25p': '25%',
        '30p': '30%',
        '33p': '33.333333%',
        '40p': '40%',
        '50p': '50%',
        '60p': '60%',
        '66p': '66.666666%',
        '70p': '70%',
        '75p': '75%',
        '80p': '80%',
        '90p': '90%',
        '100p': '100%',
        '100vh': '100vh',
        '100vw': '100vw',
    },
};
